import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'pps-delete-action',
  template: `
    <a *ngIf="showActionComponent()" class="action-icon p-1 text-danger" (click)="delete($event)" href="#"><i class="{{getIcon()}}" title="{{getTooltip()}}"></i></a>
  `,
  styles: [
  ],
})
export class DeleteActionComponent implements AgRendererComponent {
  params: ICellRendererParams;

  refresh(params: any): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  afterGuiAttached?(params?: import("ag-grid-community").IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }

  delete(evt){
    evt.preventDefault();
    if (this.params.context.componentParent.delete){
      this.params.context.componentParent.delete(this.params.data);
    }
  }

  getTooltip(){
    if (this.params.context.componentParent.getActionComponentTooltip){
      return this.params.context.componentParent.getActionComponentTooltip(this.params.data);
    }

    return "";
  }

  getIcon(){
    if (this.params.context.componentParent.getActionComponentIcon){
      return this.params.context.componentParent.getActionComponentIcon(this.params.data);
    }

    return "fas fa-trash-alt fa-lg";
  }

  showActionComponent(){
    if (this.params.context.componentParent.showActionComponent){
      return this.params.context.componentParent.showActionComponent(this.params.data);
    }

    return true;
  }
}
